export const SurchargeApplicableProducts = [];
